module.exports = __webpack_public_path__ + "img/logo-IAPS.ebfb9924.jpg";